import { productIdentity } from "@papersflow/contracts";

/** PapersFlow's compact workspace label and editorial full-size wordmark. */
export function ProductBrand({
  compact = false,
  subtitle,
}: {
  readonly compact?: boolean;
  readonly subtitle?: string;
}) {
  return (
    <span className={`flex min-w-0 items-center ${compact ? "gap-1.5" : "gap-2"}`}>
      <img
        src="/logo-icon.svg"
        alt=""
        width={compact ? 18 : 22}
        height={compact ? 18 : 22}
        className={`shrink-0 ${compact ? "size-[18px] rounded-[5px]" : "size-[22px] rounded-md"}`}
      />
      <span className="min-w-0 leading-none" aria-hidden="true">
        {compact ? (
          <span className="papersflow-compact-brand block truncate text-[var(--text)]">
            {productIdentity.displayName}
          </span>
        ) : (
          <span className="block truncate font-editorial text-lg font-semibold tracking-tight text-[var(--text)]">
            Papers
            <span className="italic text-[var(--accent-text)]">Flow</span>
          </span>
        )}
        {subtitle ? (
          <span className="mt-0.5 block truncate text-[10px] text-[var(--muted-2)]">
            {subtitle}
          </span>
        ) : null}
      </span>
      <span className="sr-only">{productIdentity.displayName}</span>
    </span>
  );
}
